{
  "dss": {
    "button": {
      "back": "Wstecz",
      "cancel": "Anuluj",
      "close": "Zamknij",
      "confirmDelete": "Tak, usuń",
      "continue": "Kontynuuj",
      "logout": "Wyloguj",
      "passwordReset": "Resetuj hasło",
      "save": "Zapisz",
      "verify": "Zweryfikuj"
    },
    "error": {
      "403": "Nie masz dostępu do tej strony.",
      "404": "Ta strona nie istnieje.",
      "generic": "Wystąpił błąd. Proszę spróbować ponownie później.",
      "throttling": "Zbyt wiele prób. Ta operacja jest chwilowo zablokowana.",
      "title": "Błąd",
      "title403": "Odmowa dostępu",
      "title404": "Nie znaleziono"
    },
    "footer": {
      "imprint": "Impressum",
      "legalEntity": "ANDREAS STIHL Sp. z o.o.",
      "privacy": "Polityki Prywatności",
      "terms": "Warunki Użytkowania"
    },
    "label": {
      "CRMAccountNumber": "Numer konta CRM",
      "contact": "Kontakt",
      "email": "Email",
      "faq": "FAQ",
      "female": "Pani",
      "firstname": "Imię",
      "help": "Pomoc",
      "language": "Język",
      "lastname": "Nazwisko",
      "male": "Pan",
      "needHelp": "Potrzebujesz pomocy?",
      "newPassword": "Nowe hasło",
      "newPassword2": "Powtórz nowe hasło",
      "oldPassword": "Aktualne hasło",
      "organization": "Firma",
      "password": "Password",
      "required": "wymagane",
      "salutation": "TYTUŁ",
      "select": "Proszę wybrać"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Potwierdzenie rejestracji",
        "wait": "Proszę czekać na zakończenie potwierdzenia konta."
      },
      "otp": {
        "btnResend": "Kod weryfikacyjny został wysłany ponownie",
        "msg": {
          "invalidOTP": "Wprowadzone hasło jednorazowe jest nieprawidłowe.",
          "resendFail": "Nie udało się ponownie wysłać kodu. Proszę spróbować ponownie później."
        },
        "spamDetail": "Sprawdź skrzynkę mailową oraz spam i wyszukaj wiadomość od STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Nie otrzymałeś maila?",
        "subtitle": "Aby kontynuować, musisz zweryfikować swój adres e-mail.",
        "title": "Zweryfikuj swoje konto",
        "txtVerifyMail": "Proszę podać kod weryfikacyjny wysłany na adres email {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Nie ma nic do aktualizacji.",
          "updateError": "Nie udało się zaktualizować danych osobowych.",
          "updated": "Dane osobowe zostały zaktualizowane.",
          "userLoadErr": "Błąd ładowania danych użytkownika. Proszę spróbować ponownie później."
        },
        "secOrganization": "ORGANIZACJA",
        "secPersonal": "Dane Osobowe",
        "secSettings": "PREFEROWANE USTAWIENIA",
        "title": "Informacje Osobiste"
      },
      "postPwSet": {
        "info": "Teraz możesz korzystać z nowego hasła.",
        "link_name": "Kontynuuj z Self-Service",
        "title": "Twoje hasło zostało zmienione"
      },
      "resetPW": {
        "title": "RESETUJ SWOJE HASŁO"
      },
      "security": {
        "2fa": {
          "availableMethods": "Dostępne metody 2FA:",
          "info": "Uwierzytelnianie dwuskładnikowe (2FA) to funkcja bezpieczeństwa, która dodaje dodatkową warstwę ochrony do Twojego konta. Wymaga użycia dwóch metod logowania zamiast tylko nazwy użytkownika i hasła.",
          "method": {
            "email": "E-mail",
            "emailDesc": "Otrzymaj jednorazowe kody e-mailem, aby zrealizować żądania uwierzytelnienia.",
            "oath": {
              "add": {
                "button": "Zarejestruj aplikację Authenticator"
              }
            }
          }
        },
        "authenticator": "Aplikacja Authenticator",
        "infoFederatedAccount": "To konto jest zarządzane przez dostawcę tożsamości Twojej organizacji, dlatego hasła nie można tutaj zmienić. Aby zmienić hasło, zaloguj się przez stronę logowania swojej organizacji lub skontaktuj się z administratorem IT.",
        "lastUse": "Ostatnio użyto o {0}.",
        "msg": {
          "invalidPassword": "Podano nieprawidłowe aktualne hasło.",
          "passwordAlreadyUsed": "Nie można Użyj ponownie 5 ostatnich haseł.",
          "pwUpdateError": "Wystąpił błąd podczas próby zmiany hasła.",
          "pwUpdated": "Hasło zostało zmienione."
        },
        "noDevice": "Nie skonfigurowano",
        "oathAdd": {
          "appInfo": "Aby ułatwić proces logowania do STIHL, możesz użyć aplikacji uwierzytelniających, takich jak {0}, {1}, {2} itd., do wygenerowania jednorazowego hasła, które będzie używane jako uwierzytelnianie dwuskładnikowe podczas logowania.<br/>Jeśli zgubiłeś lub zapomniałeś urządzenie mobilne, nadal możesz w dowolnym momencie skorzystać z kodu 2FA wysłanego e-mailem.<br/><br/>Postępuj zgodnie z poniższymi instrukcjami, aby skonfigurować urządzenie uwierzytelniające.",
          "badCode": "Nieprawidłowy kod, spróbuj ponownie.",
          "error": "Wystąpił błąd podczas próby rejestracji urządzenia uwierzytelniającego.",
          "headScan": "1. Zeskanuj kod QR za pomocą aplikacji uwierzytelniającej",
          "headVerify": "2. Zweryfikuj kod",
          "infoKey": "klucz konfiguracji",
          "infoKeyTitle": "Twój sekret uwierzytelniania dwuskładnikowego",
          "infoScanBottom": "Nie można skanować? Możesz użyć {0}, aby ręcznie skonfigurować aplikację uwierzytelniającą.",
          "infoVerify": "Wprowadź kod wygenerowany przez aplikację uwierzytelniającą.",
          "success": "Twoje urządzenie uwierzytelniające zostało zarejestrowane. Możesz teraz go używać do logowania.",
          "title": "Zarejestruj urządzenie do uwierzytelniania dwuskładnikowego"
        },
        "oathDelete": {
          "error": "Wystąpił błąd podczas próby usunięcia urządzenia uwierzytelniającego.",
          "success": "Urządzenie uwierzytelniające zostało usunięte."
        },
        "passkeys": {
          "about": {
            "info1": "Hasła to pary kluczy kryptograficznych (klucz publiczny i klucz prywatny), które są przechowywane przez kontrolowany przez Ciebie program uwierzytelniający. Program uwierzytelniający może potwierdzić obecność użytkownika i jego upoważnienie do korzystania z hasła. Programy uwierzytelniające potwierdzają autoryzację za pomocą kodu PIN, hasła, danych biometrycznych lub hasła urządzenia, w zależności od możliwości i konfiguracji programu uwierzytelniającego. Programy uwierzytelniające występują w wielu formach, takich jak iPhone lub urządzenie z systemem Android, Windows Hello, sprzętowy klucz bezpieczeństwa FIDO2 lub menedżer haseł.",
            "info2": "Kiedy logujesz się do STIHL za pomocą hasła, program uwierzytelniający używa kryptografii klucza publicznego, aby potwierdzić Twoją tożsamość bez konieczności wysyłania hasła. Hasła są powiązane z domeną witryny, taką jak stihl-sso.com, i wymagają bezpiecznego połączenia, co oznacza, że ​​przeglądarka internetowa odmówi uwierzytelnienia na podejrzanej witrynie phishingowej. Te właściwości sprawiają, że klucze są wysoce odporne na phishing i znacznie trudniejsze do zaatakowania niż SMS-y. lub TOTP 2FA, które mogą paść ofiarą phishingu.",
            "info3": "Usługi kluczy dostępu oparte na chmurze umożliwiają synchronizację kluczy dostępu między urządzeniami (takimi jak urządzenia Apple, urządzenia z Androidem lub menedżery haseł), dzięki czemu można ich używać z wielu miejsc i są one mniej podatne na utratę. Po skonfigurowaniu zsynchronizowanego klucza dostępu na jednym urządzeniu, jest on dostępny do użycia na wielu urządzeniach korzystających z tej samej usługi. Na przykład, jeśli zarejestrujesz klucz dostępu na swoim koncie iCloud za pomocą Touch ID w MacBooku, możesz używać go zamiennie z twarzą, odciskiem palca, kodem PIN lub hasłem urządzenia na wielu urządzeniach powiązanych z tym samym kontem iCloud.",
            "title": "Informacje o kluczach dostępu"
          },
          "add": {
            "button": "Dodaj nowy klucz dostępu",
            "error": "Wystąpił błąd podczas próby dodania nowego klucza dostępu.",
            "success": "Dodano nowy klucz dostępu."
          },
          "delete": {
            "button": "Usuń klucz dostępu",
            "error": "Wystąpił błąd podczas próby usunięcia tego klucza dostępu.",
            "success": "Klucz dostępu został usunięty."
          },
          "edit": {
            "error": "Wystąpił błąd podczas próby zapisania nazwy klucza dostępu.",
            "name": "Nazwa klucza dostępu",
            "success": "Nazwa klucza dostępu została zaktualizowana.",
            "title": "Nadaj swojemu kluczowi dostępu nazwę, aby odróżnić go od innych kluczy dostępu."
          },
          "info": "Klucz dostępu to prosta i bezpieczna alternatywa dla haseł, która weryfikuje tożsamość za pomocą dotyku, rozpoznawania twarzy, hasła urządzenia lub kodu PIN.",
          "none": "Nie skonfigurowano klucza dostępu.",
          "reallyDelete": "Czy na pewno chcesz usunąć klucz dostępu?",
          "registeredPasskeys": "Twoje zarejestrowane klucze dostępu:",
          "title": "Klucze dostępu"
        },
        "reallyDeleteDevice": "Czy na pewno chcesz usunąć urządzenie uwierzytelniające?",
        "secMFA": "Uwierzytelnianie dwuskładnikowe",
        "secPwdChange": "Zmień hasło",
        "title": "Bezpieczeństwo"
      },
      "setPW": {
        "acceptTC": "Proszę potwierdzić {terms} oraz przeczytanie {privacy}",
        "killSSO": "Unieważnij wszystkie aktywne sesje",
        "msg": {
          "tokenExpired": "Link do hasła lub kod wygasł. Proszę skorzystać z linku, aby zresetować hasło: {link}."
        },
        "privacy": "Polityki Prywatności",
        "terms": "Warunki Użytkowania",
        "title": "Podaj nowe hasło"
      }
    },
    "validations": {
      "hasDigit": "Musi zawierać cyfrę",
      "hasLowercase": "Musi zawierać małe litery.",
      "hasSpecial": "Musi zawierać znak specjalny: {chars}",
      "hasUppercase": "Musi zawierać duże litery.",
      "invalidCharacters": "Zawiera nieprawidłowe znaki",
      "maxLength": "Maksymalnie {max} dozwolone znaki",
      "minLength": "Minimum {min} znaków",
      "notSameAsEmail": "Zbyt podobny do adresu e-mail",
      "onlyValidCharactersAllowed": "Dozwolone są tylko litery, cyfry i spacje.",
      "required": "Wymagana wartość",
      "sameAsPassword": "Hasła nie są zgodne",
      "tcAccepted": "Potwierdź nasze warunki.",
      "validEmail": "Nieprawidłowy adres e-mail.",
      "validOTP": "Proszę wprowadzić kod weryfikacyjny."
    }
  }
}
